const EMAIL_SENDER_PAGINATION_KEY = 'emailSenderPagination';
const EMAIL_SENDERS_PATH_PREFIX = '/outreach/email-senders';

const isEmailSendersPath = (pathname) =>
  pathname === EMAIL_SENDERS_PATH_PREFIX ||
  pathname?.startsWith(`${EMAIL_SENDERS_PATH_PREFIX}/`);

const DEFAULT_PAGINATION = {
  page: 0,
  perPage: 50,
  search: '',
  statsFilter: '',
  searchFolder: '',
  ownedBy: undefined,
};

export const getEmailSenderFilters = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(EMAIL_SENDER_PAGINATION_KEY));
    const page = parseInt(stored?.page, 10);
    const perPage = parseInt(stored?.perPage, 10);
    return {
      ...DEFAULT_PAGINATION,
      ...stored,
      page: Number.isInteger(page) && page >= 0 ? page : DEFAULT_PAGINATION.page,
      perPage: Number.isInteger(perPage) && perPage >= 1 ? perPage : DEFAULT_PAGINATION.perPage,
      search: stored?.search ?? '',
      statsFilter: stored?.statsFilter ?? '',
      searchFolder: stored?.searchFolder ?? '',
      ownedBy: stored?.ownedBy,
    };
  } catch (err) {
    return { ...DEFAULT_PAGINATION };
  }
};

export const saveEmailSenderFilters = (filters) => {
  try {
    sessionStorage.setItem(
      EMAIL_SENDER_PAGINATION_KEY,
      JSON.stringify(filters)
    );
  } catch (err) {}
};

export const clearEmailSenderPaginationIfAway = (pathname) => {
  if (isEmailSendersPath(pathname)) return;
  try {
    sessionStorage.removeItem(EMAIL_SENDER_PAGINATION_KEY);
  } catch (err) {}
};
